export default {
  productTypeTitle: 'Group insurance',
  productTypeSubTitle: 'Group plan:',
};
